import MapboxDraw, { DrawCustomModeThis, DrawFeature, DrawLineString, DrawPoint } from "@mapbox/mapbox-gl-draw";

import { inPole, inSpan } from "fond/layers";

import * as topologyHelper from "../topologyHelper";

export { getFeatureId } from "../topologyHelper";

/**
 * Aerial topology config — binds the shared helpers to the span/pole layer IDs.
 */
export const aerialConfig: topologyHelper.TopologyConfig = { lineLayerId: inSpan, pointLayerId: inPole };

/**
 * Splits a span into two segments at the given pole location.
 * Delegates to the parameterized topologyHelper with aerial layer IDs.
 */
export function splitPaths(this: DrawCustomModeThis, path: DrawLineString, pole: DrawPoint): DrawLineString[] {
  return topologyHelper.splitPaths.call(this, aerialConfig, path, pole);
}

/**
 * Checks for collocated features (spans or poles) at the given feature's location.
 * Delegates to the parameterized topologyHelper and maps the return type
 * from { lines, points } to { spans, poles } for backward compatibility.
 */
export function pullInFeatures(
  this: DrawCustomModeThis,
  feature: DrawFeature,
  connectedIds?: Set<string | number>,
  type?: MapboxDraw.MapMouseEvent["type"]
): { spans: DrawLineString[]; poles: DrawPoint[] } {
  const { lines, points } = topologyHelper.pullInFeatures.call(this, aerialConfig, feature, connectedIds, type);
  return { spans: lines, poles: points };
}

/**
 * Checks if a pole feature is snapped to any spans.
 * Delegates to the parameterized topologyHelper.
 */
export function refreshSnappedStatus(this: DrawCustomModeThis, feature: DrawPoint): void {
  topologyHelper.refreshSnappedStatus.call(this, aerialConfig, feature);
}
